import o from "./index149.js";
/* empty css         */
import t from "./index130.js";
const p = /* @__PURE__ */ t(o, [["__scopeId", "data-v-368958d5"]]);
export {
  p as default
};
